import { createSystem, defineConfig, defaultConfig } from "@chakra-ui/react"

const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        palomma: {
          50: { value: "#f4f0ff" },
          100: { value: "#e6dbff" },
          200: { value: "#d0b8ff" },
          300: { value: "#b38eff" },
          400: { value: "#8e5cff" },
          500: { value: "#4012AB" }, // Primary Brand Color
          600: { value: "#320e8a" },
          700: { value: "#260a69" },
          800: { value: "#1b074a" },
          900: { value: "#11032e" },
          950: { value: "#09011a" },
        },
      },
      shadows: {
        subtle: {
          value:
            "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 1px 2px 0px",
        },
      },
      fonts: {
        heading: { value: "Rethink Sans, sans-serif" },
        body: { value: "Geist, sans-serif" },
      },
    },
    semanticTokens: {
      colors: {
        bg: {
          default: {
            value: { _light: "white", _dark: "#09090b" },
          },
          panel: {
            value: { _light: "white", _dark: "#121215" },
          },
          muted: {
            value: { _light: "{colors.gray.50}", _dark: "#18181b" },
          },
          subtle: {
            value: { _light: "{colors.gray.100}", _dark: "#27272a" },
          },
        },
        fg: {
          default: {
            value: { _light: "{colors.palomma.900}", _dark: "#fafafa" },
          },
          muted: {
            value: {
              _light: "{colors.gray.500}",
              _dark: "#a1a1aa",
            },
          },
          subtle: {
            value: {
              _light: "{colors.gray.400}",
              _dark: "#71717a",
            },
          },
        },
        border: {
          default: {
            value: { _light: "{colors.gray.200}", _dark: "#27272a" },
          },
          subtle: {
            value: { _light: "{colors.gray.100}", _dark: "#1e1e22" },
          },
        },
        brand: {
          solid: {
            value: {
              _light: "{colors.palomma.500}",
              _dark: "{colors.palomma.400}",
            },
          },
          contrast: { value: "white" },
          fg: {
            value: {
              _light: "{colors.palomma.700}",
              _dark: "{colors.palomma.200}",
            },
          },
          muted: {
            value: {
              _light: "{colors.palomma.50}",
              _dark: "rgba(179, 142, 255, 0.1)",
            },
          },
          subtle: {
            value: {
              _light: "{colors.palomma.100}",
              _dark: "rgba(179, 142, 255, 0.15)",
            },
          },
          emphasized: { value: "{colors.palomma.300}" },
          focusRing: { value: "{colors.palomma.500}" },
        },
      },
    },
  },
})

export const system = createSystem(defaultConfig, config)
